import { useCallback, useEffect, useRef, useState } from 'react';

/** @internal */
export const useCopyToClipboard = (
  value: string,
): [() => void, boolean, (value: boolean) => void] => {
  const copyableString = useRef(value);
  const [copied, setCopied] = useState(false);
  const copyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(copyableString.current);
    setCopied(true);
  }, [copyableString]);

  useEffect(() => {
    copyableString.current = value;
    setCopied(false);
  }, [value]);

  return [copyToClipboard, copied, setCopied];
};
